import React from 'react';
import SvgWrapper from './SvgWrapper.js';

export default function Star(props) {
  return (
    <SvgWrapper angle={props.angle} scale={props.scale} left={props.left} top={props.top}>
      <svg width="76" height="73" viewBox="0 0 76 73" fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M38 3L48.815 24.91L73 28.445L55.5 45.49L59.63 69.57L38 58.195L16.37 69.57L20.5 45.49L3 28.445L27.185 24.91L38 3Z" 
          stroke={props.color || "#4285F4"} stroke-width={props.thick || "6"} stroke-linecap="round" 
          stroke-linejoin="round"/>
      </svg>
    </SvgWrapper>
  )
}
